import { Box, CircularProgress, Grid, Stack } from "@mui/material";
import useGetScriptById from "hooks/api/useGetScriptById";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import FormScript from "../FormScript";
import useFormHelpers from "../FormScript/hooks/useFormHelpers";
import BtnClose from "../components/BtnClose";
import BtnDelete from "../components/BtnDelete";
import BtnDownload from "../components/BtnDownload";
import BtnDuplicate from "../components/BtnDuplicate";
import BtnPublish from "../components/BtnPublish";
import BtnSaveDraft from "../components/BtnSaveDraft";
import MobilePublishedDisplay from "./MobilePublishedDisplay";

export default function ViewDetails() {
  const { activeId } = useParams() as { activeId: string };
  const { script } = useGetScriptById({ scriptId: activeId });
  const { isMobilePublished, updateStateFromScript, isModerated } =
    useFormHelpers();

  useEffect(() => {
    if (script) {
      updateStateFromScript(script);
    }
  }, [script]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={({ palette }) => ({
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${palette.grey[400]}`,
        })}
      >
        <Stack direction="row" spacing={1}>
          <BtnSaveDraft />
          {!isModerated() && <BtnPublish />}
          <BtnDuplicate />
          <BtnDownload />
          <BtnDelete />
        </Stack>
        <BtnClose />
      </Box>

      <Box
        sx={({ props }) => ({
          overflowY: "auto",
          overflowX: "hidden",
          ...props.cssScrollbarWidth,
          p: 2,
        })}
      >
        <Box>
          {!script && (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          )}
          {script &&
            (isMobilePublished() ? <MobilePublishedDisplay /> : <FormScript />)}
        </Box>
      </Box>
    </Box>
  );
}
